import { Pipe, PipeTransform } from '@angular/core';
import { CustomTest } from 'src/app/models/custom_test_model';

@Pipe({
  name: 'testGroup'
})
export class TestGroupPipe implements PipeTransform {

  transform(value: CustomTest[], groupId: string): CustomTest[] {
    let response = value.filter(test => test.groupId === groupId)
    return response
  }

}
